import styled from 'styled-components'
import { breakpoints } from '../../../../../../constants'
import {
	SILVER,
	DARKGRAY,
	GREEN,
	STRONGORANGE,
} from '../../../../../../styles/colors.style'

export const BoxList = styled.ul`
	list-style: none;
	padding: 0;
	margin: 0;

	@media (min-width: ${breakpoints.MOBILE}px) {
		display: none;
	}
`

export const Item = styled.ul`
	list-style: none;
	padding: 6px 0;
	border-bottom: 1px solid ${SILVER};
	display: flex;

	li {
		color: ${DARKGRAY};
		display: flex;
		flex-direction: column;
		justify-content: center;
		flex: 1;
		text-align: right;

		&:first-child {
			text-align: left;
			flex: 2;
		}

		p {
			font: 600 15px/19px 'Source Sans Pro';
			&.trCredit,
			&.trPayment {
				color: ${GREEN} !important;
			}
		}
		&:first-child {
			small {
				color: ${STRONGORANGE} !important;
			}
		}
		&:last-child {
			text-align: right;
			font: 600 15px/19px 'Source Sans Pro';
			text-transform: uppercase;
			&.trCredit::before,
			&.trPayment::before {
				content: ' - ';
				display: contents;
			}
		}

		&.trCredit,
		.trCredit,
		&.trPayment,
		.trPayment {
			color: ${GREEN} !important;
		}
	}
`
